import useQueryParam from "./useQueryParam";
import {useMemo} from "react";
import AWS from "aws-sdk";


const useS3Connection = ({
                             accessKeyId,
    region,
                         }) => {
    const secretAccessKey = useQueryParam("secretKey");

    return useMemo(() => {
        return new AWS.S3({
            apiVersion: "2006-03-01",
            accessKeyId,
            secretAccessKey,
            region,
        });
    }, [secretAccessKey, accessKeyId, region])
}

export default useS3Connection;